module.exports = __webpack_public_path__ + "img/mouth-3.8849acd0.svg";